module.exports = __webpack_public_path__ + "static/media/2.7794f4fd.jpg";